/** @file Maps the current route to its screen (exhaustive over Route). */
import { EditorFrame } from '../frame/EditorFrame';
import { LoginScreen } from '../screens/LoginScreen';
import { NotFoundScreen } from '../screens/NotFoundScreen';
import { ProjectsScreen } from '../screens/projects/ProjectsScreen';
import { SettingsScreen } from '../screens/SettingsScreen';
import type { Route } from './router/parseRoute';

/** `key` on EditorFrame remounts the dock when switching projects. */
export function Screen({ route }: { route: Route }) {
  switch (route.name) {
    case 'login':
      return <LoginScreen />;
    case 'projects':
      return <ProjectsScreen />;
    case 'settings':
      return <SettingsScreen />;
    case 'editor':
      return <EditorFrame key={route.projectId} projectId={route.projectId} />;
    case 'notFound':
      return <NotFoundScreen />;
  }
}
